import styled from 'styled-components'
import { Radio } from 'antd'
import { themeColor, themeFontFamily, themeFontWeight } from 'LibNeo/theme'
import { IconComponent } from 'LibNeo/components/Basic/Icon'
import { LinkComponent } from 'LibNeo/components/Basic/Link'

interface RadioComponentProps {
	isHorizontal?: boolean
}

export const RadioCardIcon = styled(IconComponent)`
	svg {
		fill: ${({ disabled }) => themeColor('gray', disabled ? 5 : 8)};
	}
`

export const CardBodyDescription = styled.span`
	font-family: ${themeFontFamily('SBSansText')};
	font-size: 12px;
	color: ${themeColor('gray', 5)};
`

export const CardBodyTitle = styled.span`
	font-family: ${themeFontFamily('SBSansInterface')};
	font-size: 14px;
	color: ${themeColor('gray', 8)};
`

export const CardBodyOptionText = styled.div`
	min-width: fit-content;
`

export const CardBodyTitleWrapper = styled.div`
	display: inline-flex;
	width: 100%;
	justify-content: space-between;
`

export const CardBody = styled.div`
	padding: 20px;
	font-size: 14px;
	line-height: 20px;
	font-weight: ${themeFontWeight('SBSansInterface', 'regular')};
`

export const RadioGroup = styled(Radio.Group)<RadioComponentProps>`
	display: grid;
	${({ isHorizontal }) =>
		isHorizontal &&
		'grid-template-columns: repeat(auto-fit, minmax(240px, 1fr)); grid-auto-rows: 1fr;'};
	flex-wrap: wrap;
	gap: 16px;
	width: 100%;

	.ant-radio-button-wrapper {
		flex: 0 0 31.3333%;
		height: auto;
		padding: 0;
		outline: 1px solid ${themeColor('gray', 3)};
		border: initial;
		border-radius: 8px;
		min-width: 240px;

		&:not(.ant-radio-button-wrapper-disabled):hover {
			box-shadow: 0 1px 6px rgb(0 0 0 / 12%);
			color: initial;
		}

		&.ant-radio-button-wrapper-checked {
			box-shadow: initial;
			outline: 2px solid ${themeColor('emerald', 5)};
			outline-offset: -2px;
		}

		&.ant-radio-button-wrapper-disabled {
			background-color: ${themeColor('white')};
		}

		&:before {
			content: initial;
		}
	}
`
export const LinkWrapper = styled(LinkComponent)`
	text-decoration-line: underline;
	text-decoration-style: dotted;
	border-bottom: none;
	font-size: 12px;
`
